const API_BASE = import.meta.env.VITE_API_URL ?? '';

export interface KBResult {
  text: string;
  source: string;
  score: number;
}

export async function searchKB(query: string): Promise<KBResult[]> {
  if (!query.trim()) return [];
  try {
    const res = await fetch(`${API_BASE}/api/kb/search?q=${encodeURIComponent(query)}`);
    if (!res.ok) return [];
    const data = await res.json() as KBResult[];
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
